import FieldError from "./field-error"

const FileUploadError = ({ error, className }) => {
  if (!error) return null

  return (
    <FieldError
      sx={{ mt: 4 }}
      data-testid="file-upload-error"
      className={className}
    >
      {error.title || error.description ? (
        <div sx={{ textAlign: "center" }}>
          {error.title && (
            <div sx={{ mb: 1, fontWeight: "bold" }}>{error.title}</div>
          )}
          {error.description && <div>{error.description}</div>}
        </div>
      ) : (
        <div>Error: {error.message}</div>
      )}
    </FieldError>
  )
}

export default FileUploadError
